import { getBlockTitle } from '@aytm/app/insights/dashboard/components/sidebar/ReportsPanel/ReportsContext'
import { decode } from '@aytm/app/insights/dashboard/lib/sanitize'
import { defaultPreset } from '@aytm/app/insights/dashboard/lib/config'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'

import { calculateSubjectsRatio, calculateRespondentsRatio } from './Header.logic'
import { compareTuples } from '@aytm/app/insights/dashboard/lib/comparison'
import type { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'

export const stateSelector = (state: InsightsDashboardPoolState) => {
  const block = getCurrentBlock(state)
  const title = state.title || ''
  const decodedTitle = decode(title)
  const decodedSubtitle = decode(getBlockTitle(block))
  const currentPreset = block?.getObject('currentPreset') || defaultPreset
  const hideBlankColumns = (block?.hideBlankColumns || false) && 'All' === currentPreset
  const currentSplit = block?.getObject('currentSplit') || null
  const currentSwap = block?.swap || false
  const isLoading = state.isLoading || false
  const subjects = state.currentData?.subjects || null
  const { selectedSubjects, totalSubjects } = calculateSubjectsRatio(
    hideBlankColumns,
    state.currentData,
    currentSplit,
    currentSwap
  )
  const { totalRespondents, selectedRespondents } = calculateRespondentsRatio(false, state.currentData)
  return {
    decodedTitle,
    decodedSubtitle,
    currentSplit,
    isLoading,
    subjects,
    selectedSubjects,
    totalSubjects,
    totalRespondents,
    selectedRespondents
  }
}

export const shouldUpdate = (
  prev: ReturnType<typeof stateSelector> | null,
  next: ReturnType<typeof stateSelector> | null
) =>
  !prev && !next
    ? false
    : (!prev && Boolean(next)) ||
      (Boolean(prev) && !next) ||
      !compareTuples(
        ({
          decodedTitle,
          decodedSubtitle,
          currentSplit,
          isLoading,
          subjects,
          selectedSubjects,
          totalSubjects,
          totalRespondents,
          selectedRespondents
        }) => [
          decodedTitle,
          decodedSubtitle,
          currentSplit,
          isLoading,
          subjects,
          selectedSubjects,
          totalSubjects,
          totalRespondents,
          selectedRespondents
        ]
      )(prev, next)
// !prev && !next
//   ? false
//   : prev.decodedTitle !== next.decodedTitle ||
//     prev.decodedSubtitle !== next.decodedSubtitle ||
//     prev.currentSplit !== next.currentSplit ||
//     prev.isLoading !== next.isLoading ||
//     prev.subjects !== next.subjects ||
//     prev.selectedSubjects !== next.selectedSubjects ||
//     prev.totalSubjects !== next.totalSubjects ||
//     prev.totalRespondents !== next.totalRespondents ||
//     prev.selectedRespondents !== next.selectedRespondents
